<style>
  .steps-content {

    min-height: 200px;
    padding-top: 20px;
  }

  .steps-action {
    margin-top: 24px;
  }

  button {
    margin-right: 8px;
  }

  [nz-radio] {
    display: block;
    height: 32px;
    line-height: 32px;
  }

  .example {
    text-align: center;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 30px 50px;
    margin: 20px 0;
  }
</style>

<div class="">
  <div *ngIf="currentUser?.name != null" class="company-header text-center">
    <label class="btn change-company"><a href="#/dashboard" target="_blank">Dashboard</a></label>
  </div>
  <br />
  <main class="main d-flex align-items-center">
    <div class="container">
      <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
        <p style="color: white"><strong> Loading... </strong></p>
      </ngx-spinner>
      <div class="row">
        <div style="text-align: center; width: 100%;">
          <a href="https://bmsroadtax.com"> <img width="100px" alt="bms logo" height="80"
              ngSrc="assets/img/bms-eplateform-logo.png" /></a>
        </div>
        <!-- <div class="col-md-3"></div>
        <div class="col-md-5"><a href="https://bmsroadtax.com"> <img width="100px" height="70.31" src="assets/img/bms-logo.webp" /></a>
          <label style="font-weight: bold;padding-left: 10px;">Brilliant Management Services (001166576-D)</label></div>

        <div class="col-md-3"></div> -->
      </div>
      <br />
      <div class="col-md-{{cardWidth}} mx-auto">
        <div class="card border-info">
          <div class="card-header"><strong>Road Tax Renewal Quotation</strong></div>

          <div class="card-body">


            <nz-steps [nzCurrent]="current" nzSize="small">
              <nz-step nzTitle="{{step1Title}}"></nz-step>
              <nz-step nzTitle="{{step2Title}}"></nz-step>

            </nz-steps>

            <div *ngIf="isMobileScreen">
              <br />
              <strong> {{mobileStepTitle}}</strong>
            </div>
            <div class="steps-content" *ngIf="current==0">
              <div class="col-md-10 mx-auto">
                <form [formGroup]="form">
                  <div class="form-group row" *ngIf="isLoginAsAdmin()">
                    <label class="col-md-3 col-form-label">
                      <div>Bypass ISM</div>
                    </label>
                    <div class="col-md-8">
                      <nz-select class="form-control" nzBorderless nzShowSearch [nzShowArrow]="true"
                        formControlName="bypassIsm">
                        <nz-option nzValue="0" nzLabel="No"></nz-option>
                        <nz-option nzValue="1" nzLabel="Yes"></nz-option>
                      </nz-select>
                    </div>
                  </div>
                  <div class="form-group row" *ngIf="isLoginAsAdmin()">
                    <label class="col-md-3 col-form-label">
                      <div>Source</div>
                    </label>
                    <div class="col-md-8">
                      <nz-select class="form-control" nzBorderless nzShowSearch [nzShowArrow]="true"
                        formControlName="source">
                        <nz-option nzValue="2" nzLabel="Online"></nz-option>
                        <nz-option nzValue="3" nzLabel="Walk In"></nz-option>
                        <nz-option nzValue="5" nzLabel="SleekFlow"></nz-option>
                      </nz-select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Renewal Months</div>
                    </label>
                    <div class="col-md-8">
                      <select class="form-control" formControlName="renewalMonth">
                        <option value="12">12 Months</option>
                        <option value="6">6 Months</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Registration No<span class="require-asterisk">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" oninput="this.value = this.value.toUpperCase()"
                        (paste)="replaceRegistrationNoPasteValue($event)" (keypress)="keyPressAlphaNumeric($event)"
                        formControlName="vehicleNo" maxlength="8" placeholder="e.g: WMC1234" class="form-control"
                        [ngClass]="{
                                  'is-invalid': submitted &&  f.vehicleNo.errors
                                }" required />
                      <div *ngIf="submitted && f.vehicleNo.errors" class="invalid-feedback">
                        <div *ngIf="f.vehicleNo.errors.required">Registration no is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>ID Type</div>
                    </label>
                    <div class="col-md-8">
                      <select class="form-control" (change)="idtypeOnChange($event)" formControlName="idType">
                        <option value="NRIC">NRIC / MyKad</option>
                        <option value="Passport">Passport</option>
                        <option value="Army">Army</option>
                        <option value="Police">Police</option>
                        <option value="Company">Company</option>
                      </select>
                    </div>

                  </div>
                  <div class="form-group row" *ngIf="this.isCompanySelected()">
                    <label class="col-md-3 col-form-label">
                      <div>Company ID Type</div>
                    </label>
                    <div class="col-md-8">
                      <select class="form-control" (change)="companyIdtypeOnChange($event)"
                        formControlName="companyIdType">
                        <option value="old">Old Company Registration No</option>
                        <option value="new">New Company Registration No</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>ID<span class="require-asterisk">*</span></div>
                    </label>

                    <div class="col-md-8">

                      <input type="text" mask="{{idMask}}" (paste)="replacePasteValue($event)"
                        [dropSpecialCharacters]="dropSpecialCharacters" (keypress)="keyPressAlphaNumeric($event)"
                        maxlength="14" formControlName="id" placeholder='{{idTextBoxPlaceHolder}}' class="form-control"
                        [ngClass]="{
                                  'is-invalid': submitted &&  f.id.errors
                                }" />
                      <div *ngIf="submitted && f.id.errors" class="invalid-feedback">
                        <div *ngIf="f.id.errors.required">Id is required</div>
                        <div *ngIf="f.id.errors.icInvalidLength">Invalid NRIC</div>
                      </div>
                    </div>
                  </div>


                  <div style="text-align: center;" *ngIf="currentUser?.name != null">
                    <button (click)="SearchCustomer()" class="btn btn-primary">Search Customer</button>
                    <br />
                    <br />
                  </div>

                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Postcode<span class="require-asterisk">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        formControlName="postcode" placeholder="e.g: 68000" maxlength="5" class="form-control"
                        [ngClass]="{
                                'is-invalid': (submitted &&  f.postcode.errors) || f.postcode.errors?.invalidPostCode
                              }" />
                      <div *ngIf="f.postcode.errors" class="invalid-feedback">
                        <div *ngIf="f.postcode.errors?.invalidPostCode">Invalid poostcode</div>
                      </div>
                      <div *ngIf="submitted && f.postcode.errors" class="invalid-feedback">
                        <div *ngIf="f.postcode.errors.required">Postcode is required</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Mobile Number<span class="require-asterisk">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" maxlength="12" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        formControlName="contactNo" placeholder="e.g: 018666666" class="form-control" [ngClass]="{
                              'is-invalid': submitted &&  f.contactNo.errors
                            }" />
                      <div *ngIf="submitted && f.contactNo.errors" class="invalid-feedback">
                        <div *ngIf="f.contactNo.errors.required">Mobile Number is required</div>
                        <div *ngIf="f.contactNo.errors.minlength">Contact no should be 10 digits</div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-3 col-form-label">
                      <div>Email<span class="require-asterisk">*</span></div>
                    </label>
                    <div class="col-md-8">
                      <input type="text" placeholder="e.g: cindy@gmail.com" maxlength="50" formControlName="email"
                        class="form-control" [ngClass]="{
                              'is-invalid': submitted &&  f.email.errors
                            }" email />
                      <div *ngIf="pdfSubmitted && f.email.errors" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required">Email is required</div>
                        <div *ngIf="f.email.errors.email">Invalid Email</div>
                      </div>
                    </div>
                  </div>

                </form>
                <div style="text-align: center;">
                  <button type="button" class="btn btn-block btn-outline-danger active"
                    (click)="showModal()">Next</button>
                </div>
              </div>
            </div>

            <div class="steps-content" *ngIf="current==1">

              <form [formGroup]="personalDetailsForm">


                <nz-collapse nzAccordion>
                  <nz-collapse-panel nzHeader="Road Tax Info" nzActive="true" nzDisabled="false">
                    <div
                      *ngIf="!this.verifyVehicleReponseModel.vehicleInfo.isMotorcycle && !this.verifyVehicleReponseModel.vehicleInfo?.isWagon">
                      <div *ngIf="verifyVehicleReponseModel.vehicleInfo.isSaloon">
                        Vehicle Type : <strong>Saloon (Sedan / Hatchback / Wagon / Coupe / Convertible)</strong>
                      </div>
                      <div *ngIf="!verifyVehicleReponseModel.vehicleInfo.isSaloon">
                        Vehicle Type : <strong>Non-Saloon (MPV / SUV / Pick-Up / Commercial)</strong>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-5"> Registration No :
                        <strong>{{verifyVehicleReponseModel.vehicleInfo.registrationNo}}</strong></div>
                      <div class="col-md-5"> Capacity :
                        <strong>{{capacity}}</strong></div>
                    </div>
                    <div class="row">
                      <div class="col-md-5"> Brand : <strong>{{brand}}</strong>
                      </div>
                      <div class="col-md-5"> Model : <strong>{{model}}</strong>
                      </div>
                    </div>
                    <div class="row" *ngIf="this.verifyVehicleReponseModel.vehicleInfo.isMotorcycle">
                      <div class="col-md-5"> Manufacturer Year :
                        <strong>{{verifyVehicleReponseModel.vehicleInfo.manufacturingYear}}</strong></div>
                    </div>
                  </nz-collapse-panel>
                </nz-collapse>

                <br />
                <nz-collapse nzAccordion>
                  <nz-collapse-panel nzHeader="Summary" nzActive="true" nzDisabled="false">
                    <nz-table nzTemplateMode>
                      <thead>
                      </thead>
                      <tbody>
                        <tr *ngIf="this.verifyVehicleReponseModel.vehicleInfo?.isWagon">
                          <td style="border-bottom: none;"><strong>Vehicle Type</strong><br />
                            <strong style="color: red;"
                              *ngIf="this.personalDetailsForm.get('isSaloon').value == 'true'">Saloon (Sedan /
                              Hatchback / Wagon / Coupe / Convertible)</strong>
                            <strong style="color: red;"
                              *ngIf="this.personalDetailsForm.get('isSaloon').value == 'false'">Non-Saloon (MPV /
                              SUV / Pick-Up / Commercial)</strong>
                          </td>
                          <td style="border-bottom: none;text-align: right;">
                            <nz-radio-group style="display: inline-grid !important;" formControlName="isSaloon"
                              (ngModelChange)="vehicleTypeOnChange($event)">
                              <div class="row">
                                <label nz-radio nzValue="true">
                                  <strong>Saloon</strong>
                                </label>
                                <label nz-radio nzValue="false">
                                  <strong>Non-Saloon</strong>
                                </label>
                              </div>
                            </nz-radio-group>
                          </td>
                        </tr>


                        <tr>
                          <td style="border-bottom: none;"><strong> Road Tax Type</strong></td>
                          <td style="border-bottom: none;;text-align: right;">
                            <nz-radio-group style="display: inline-grid !important;vertical-align:middle;"
                              formControlName="roadTaxType" (ngModelChange)="roadTaxTypeOnChange($event)">
                              <div class="row">
                                <label nz-radio nzValue="0">
                                  <strong>Digital + Physical</strong>
                                </label>
                                <label nz-radio nzValue="1">
                                  <strong>Digital Only</strong>
                                </label>
                              </div>
                            </nz-radio-group>
                          </td>
                        </tr>
                        <tr>
                          <td style="border-bottom: none;"><strong>Shipping Option</strong></td>
                          <td style="border-bottom: none;text-align: right;">
                            <nz-radio-group style="display: inline-grid !important;" formControlName="shippingOption"
                              nzDisabled="{{disableShippingOption}}" (ngModelChange)="shippingOptionOnChange($event)">
                              <div class="row">
                                <label nz-radio nzValue="0">
                                  <strong>Delivery</strong>
                                </label>
                                <label nz-radio nzValue="1">
                                  <strong>Self Collect</strong>
                                </label>
                              </div>
                            </nz-radio-group>
                          </td>
                        </tr>
                        <tr>
                          <td style="border-bottom: none;"><strong>{{roadTaxType}} Road Tax</strong> <strong
                              style="color: red;">({{  getRenewalMonth()}} Months)</strong></td>
                          <td style="border-bottom: none;;text-align: right;">
                            {{roadTaxAmount | currency :'RM ':'symbol':'1.2-2'}}
                          </td>
                        </tr>
                        <tr>
                          <td style="border-bottom: none;"> <strong>Runner to JPJ Service</strong></td>
                          <td style="border-bottom:  none;text-align: right;">
                            {{runnerService  | currency :'RM ':'symbol':'1.2-2'}}</td>
                        </tr>
                        <tr>
                          <td style="border-bottom: none;"> <strong>Delivery Service</strong></td>
                          <td style="border-bottom:  none;text-align: right;">
                            {{deliveryService  | currency :'RM ':'symbol':'1.2-2'}}</td>
                        </tr>
                        <tr>
                          <td style="border-bottom: none;"> <strong>Service Charge</strong></td>
                          <td style="border-bottom:  none;text-align: right;">
                            {{serviceCharge  | currency :'RM ':'symbol':'1.2-2'}}</td>
                        </tr>
                        <!-- <tr >
                          <td style="border-bottom: none;"> <strong>Service Charge</strong></td>
                          <td style="border-bottom:  none;text-align: right;">
                            {{serviceCharge| currency :'RM ':'symbol':'1.2-2'}}</td>
                        </tr> -->
                        <tr>
                          <td style="border-bottom: 1pt solid"></td>
                          <td style="border-bottom: 1pt solid;text-align: right;">
                          </td>
                        </tr>
                        <tr>
                          <td style="border-bottom: 1pt solid"> <strong>Total Amount</strong></td>
                          <td style="border-bottom: 1pt solid;text-align: right;">
                            <strong>{{totalAmount| currency :'RM ':'symbol':'1.2-2'}}</strong></td>
                        </tr>
                      </tbody>
                    </nz-table>
                  </nz-collapse-panel>
                </nz-collapse>

                <br />
                <div>
                  <nz-collapse nzAccordion>
                    <nz-collapse-panel nzHeader="Customer Info" nzActive="true" nzDisabled="false">


                      <div class="form-group row" *ngIf="!isDeliverySelected() && isPhysicalRoadTaxSelected()">
                        <label class="col-md-3 col-form-label">
                          <div>Collection Branch</div>
                        </label>
                        <div class="col-md-8">
                          <nz-select nzShowSearch nzAllowClear formControlName="selfCollectBranchId"
                            (ngModelChange)="branchOnChange($event)" class="form-control" [nzShowArrow]="true"
                            nzBorderless nzPlaceHolder="Please select"
                            [ngClass]="{ 'is-invalid': pdfSubmitted &&  pdf.selfCollectBranchId.errors }">
                            <nz-option *ngFor="let branch of branchList" [nzLabel]="branch.name" [nzValue]="branch.id">
                            </nz-option>
                          </nz-select>
                          <div *ngIf="pdfSubmitted && pdf.selfCollectBranchId.errors" class="invalid-feedback">
                            <div *ngIf="pdf.selfCollectBranchId.errors.required">Collection branch is required</div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group row"
                        *ngIf="!isDeliverySelected() && this.personalDetailsForm.get('selfCollectBranchId').value != ''">
                        <div class="col-md-12">
                          <label><strong>Address:</strong> {{address}}</label><br />

                          <label><strong>Contact No:</strong> {{contactNo1}}</label><label *ngIf="contactNo2!=''"> /
                            {{contactNo2}}</label><br />
                          <label><strong>Whatsapp: </strong> <a target="_blank"
                              href="https://api.whatsapp.com/send?phone={{whatsapp}} ">6{{whatsapp}} </a></label><br />
                          <label><strong>Working Hour </strong></label>
                          <div [innerText]="workingHour"></div><br />
                        </div>
                      </div>
                      <div class="form-group row" *ngIf="!isPhysicalRoadTaxSelected()">
                        <div class="col-md-12">
                          <label><strong style="color: red;">Kindly download MyJPJ App for your digital road tax, it
                              will reflected in the App within 5-10 minute once payment done.</strong></label><br />
                        </div>
                      </div>
                      <div class="form-group row" *ngIf="isPhysicalRoadTaxSelected()">
                        <div class="col-md-12">
                          <label><strong style="color: red;">Our staff will share you the courier[ETA: 2-3 workings day]
                              detail once payment done.</strong></label><br />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label">
                          <div>Receiver Name<span class="require-asterisk">*</span></div>
                        </label>
                        <div class="col-md-8 text-right">
                          <input type="text" formControlName="name" placeholder="e.g: Johanson"
                            class="form-control capitalise" [ngClass]="{
                                    'is-invalid': pdfSubmitted &&  pdf.name.errors
                                  }" required />
                          <div *ngIf="pdfSubmitted && pdf.name.errors" class="invalid-feedback">
                            <div *ngIf="pdf.name.errors.required">Name is required</div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group row">
                        <label class="col-md-3 col-form-label">
                          <div>Mobile Number<span class="require-asterisk">*</span></div>
                        </label>
                        <div class="col-md-8">
                          <input type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            formControlName="contactNo1" maxlength="12" placeholder="e.g: 018666666"
                            class="form-control" [ngClass]="{
                                'is-invalid': pdfSubmitted &&  pdf.contactNo1.errors
                              }" />
                          <div *ngIf="pdfSubmitted && pdf.contactNo1.errors" class="invalid-feedback">
                            <div *ngIf="pdf.contactNo1.errors.required">Mobile Number is required</div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label">
                          <div>Second Mobile Number. <label style="color: red;">[Optional]</label></div>
                        </label>
                        <div class="col-md-8">
                          <input type="text" formControlName="contactNo2" maxlength="12"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            placeholder="e.g: 018666666" class="form-control" [ngClass]="{
                                'is-invalid': pdfSubmitted &&  pdf.contactNo2.errors
                              }" />
                          <div *ngIf="pdfSubmitted && pdf.contactNo2.errors" class="invalid-feedback">
                            <div *ngIf="pdf.contactNo2.errors.required">Mobile Number is required</div>
                          </div>
                        </div>
                      </div>


                      <div class="form-group row" *ngIf="isDeliverySelected()">
                        <label class="col-md-3 col-form-label">
                          <div>Address Line 1 <span class="require-asterisk">*</span></div>
                        </label>
                        <div class="col-md-8">
                          <input maxlength="50" formControlName="address1" rows="3" placeholder=""
                            class="form-control capitalise" [ngClass]="{
                              'is-invalid': pdfSubmitted &&  pdf.address1.errors
                            }" />
                          <div *ngIf="pdfSubmitted && pdf.address1.errors" class="invalid-feedback">
                            <div *ngIf="pdf.address1.errors.required">Address 1 is required</div>
                          </div>
                        </div>

                      </div>
                      <div class="form-group row" *ngIf="isDeliverySelected()">
                        <label class="col-md-3 col-form-label">
                          <div>Address Line 2 <span class="require-asterisk">*</span></div>
                        </label>
                        <div class="col-md-8">
                          <input maxlength="50" formControlName="address2" rows="3" placeholder=""
                            class="form-control capitalise" [ngClass]="{
                              'is-invalid': pdfSubmitted &&  pdf.address2.errors
                            }" />
                          <div *ngIf="pdfSubmitted && pdf.address2.errors" class="invalid-feedback">
                            <div *ngIf="pdf.address2.errors.required">Address 2 is required</div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row" *ngIf="isDeliverySelected()">
                        <label class="col-md-3 col-form-label">
                          <div>State</div>
                        </label>
                        <div class="col-md-8">
                          <nz-select class="form-control" formControlName="state" style="height: auto"
                            nzPlaceHolder="Please select" [nzShowArrow]="true" nzShowSearch nzBorderless>

                            <nz-option nzValue="Selangor" nzLabel="Selangor"></nz-option>
                            <nz-option nzValue="Kuala Lumpur" nzLabel="Kuala Lumpur"></nz-option>
                            <nz-option nzValue="Johor" nzLabel="Johor"></nz-option>
                            <nz-option nzValue="Kedah" nzLabel="Kedah"></nz-option>
                            <nz-option nzValue="Kelantan" nzLabel="Kelantan"></nz-option>
                            <nz-option nzValue="Melaka" nzLabel="Melaka"></nz-option>
                            <nz-option nzValue="Negeri Sembilan" nzLabel="Negeri Sembilan"></nz-option>
                            <nz-option nzValue="Pahang" nzLabel="Pahang"></nz-option>
                            <nz-option nzValue="Perak" nzLabel="Perak"></nz-option>
                            <nz-option nzValue="Perlis" nzLabel="Perlis"></nz-option>
                            <nz-option nzValue="Pulau Pinang" nzLabel="Pulau Pinang"></nz-option>
                            <nz-option nzValue="Putrajaya" nzLabel="Putrajaya"></nz-option>
                            <nz-option nzValue="Terengganu" nzLabel="Terengganu"></nz-option>
                          </nz-select>
                        </div>
                      </div>
                      <div class="form-group row" *ngIf="isDeliverySelected()">
                        <label class="col-md-3 col-form-label">
                          <div>Postcode<span class="require-asterisk">*</span></div>
                        </label>
                        <div class="col-md-8">
                          <input type="text" maxlength="5"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57" formControlName="postcode"
                            placeholder="e.g: 68000" maxlength="5" class="form-control" [ngClass]="{
                                  'is-invalid': pdfSubmitted &&  pdf.postcode.errors
                                }" required />
                          <div *ngIf="pdfSubmitted && pdf.postcode.errors" class="invalid-feedback">
                            <div *ngIf="pdf.postcode.errors.required">Postcode is required</div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label">
                          <div>Remark</div>
                        </label>
                        <div class="col-md-8">
                          <textarea formControlName="remark" maxlength="1000" rows="3" placeholder=""
                            class="form-control capitalise">
                          </textarea>
                        </div>

                      </div>
                      <div>
                      </div>
                    </nz-collapse-panel>
                  </nz-collapse>
                  <br>
                </div>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn btn-block btn-outline-danger active" (click)="pre()">Back</button>
                  </div>
                  <div class="col-6">
                    <button type="button" class="btn btn-block btn-outline-danger active" (click)="makePayment()">Make
                      Payment</button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
        <div style="text-align: center;font-size: 10px;"> <label><Strong>Copyright ©️  2025 BMS ROADTAX E PLATFORM
              202403148877 (KT0570731-V). All Rights
              Reserved.</Strong></label></div>

      </div>



    </div>


    <nz-modal [(nzVisible)]="isVisible" nzClosable="false" nzTitle="Disclaimer" (nzOnCancel)="handleCancel()"
      (nzOnOk)="handleOk()">

      <ng-container *nzModalContent>
        <p>• Have a <strong style="color: red;">valid</strong> vehicle insurance</p>
        <p>• <strong style="color: red;">Not blacklisted</strong> by JPJ/PDRM</p>
        <p>• Road tax <strong style="color: red;">expired not more than 3 years</strong></p>
        <p>• <strong style="color: red;">Not</strong> a <strong style="color: red;">grab car</strong> Road Tax</p>
        <p>• Only <strong style="color: red;">FPX</strong> payment is accepted for Road Tax</p>
      </ng-container>
    </nz-modal>